import '../sass/style.scss';
import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';
import 'waypoints/lib/noframework.waypoints';
import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import HideHeaderOnScroll from './HideHeaderOnScroll'
import FadeInWaypoints from './FadeInWaypoints'
import 'lazysizes';
import MiniMasonry from "minimasonry";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

class searchEmployees {

    constructor() {

        this.masonry = null;
        this.masonryContainer = $('#masonry-container');
        this.masonryItems = [];
        this.waypoints = [];
        this.searchInput = $('input[name="search"]');
        this.timeout = null;
        this.query = '';

        if ( this.searchInput.length > 0 ) {
            this.init();
        }

    }


    registerWaypoint( item ) {
        let waypoint = new Waypoint({
            element: item,
            handler: function( direction ) {
                if ( direction === 'down' ) {
                    item.classList.add('visible');
                } else {
                    item.classList.remove('visible');
                }
            },
            offset: '90%'
        });
        this.waypoints.push(waypoint);
    }

    showEmpty() {

        let $item = $('<div />').addClass('employees-list--item');
        let $message = $('<span />').addClass('name').html('Ingen treff på "'+query+'"');

        $item.append($message);

        setTimeout(() => {
            this.masonryContainer.append($item);
            this.registerWaypoint( $item[0] );
            this.masonry.appended( $item[0] );
            this.masonryItems.push( $item[0] );
        }, 100);

    }

    buildMarkup(item) {
        
        let $item = $('<div />').addClass('employees-list--item');

        let $image = null;
        if ( item.image ) {
            $image = new Image;
            $image.src = item.image.smallImage;
            $image.sizes = '(min-width: 1540px) 434px, (min-width: 1024px) 30vw, (min-width: 640px) 46vw, 100vw';
            $image.width = item.image.width;
            $image.height = item.image.height;
            $image.srcset = item.image.srcset
            $item.append($image);
        }

        let $name = $('<span />').addClass('name').html(item.title);
        let $occupation = $('<span />').addClass('occupation').html(item.occupation);
        $item.append($name, $occupation);

        let $email = '';
        if ( item.emailAddress && item.emailAddress.length > 0 ) {
            $email = $('<a />').addClass('emailAddress').attr('href', 'mailto:'+item.emailAddress).html(item.emailAddress);
            let $break = $('<br />');
            $item.append($email, $break);
        }
        
        let $phone = '';
        if ( item.phoneNumber && item.phoneNumber.length > 0 ) {
            $phone = $('<a />').addClass('phoneNumber').attr('href', 'tel:'+item.phoneNumber.replace(' ','')).html(item.phoneNumber);
            $item.append($phone);
        }

        return {
            markup: $item, 
            image: $image
        };

    }


    countLoadedImages( index ) {

    }


    renderItems( items ) {

        // Clear container
        this.waypoints.map(item => {
            item.destroy();
        });
        this.waypoints = [];

        this.masonryItems.map(item => {
            this.masonry.remove(item);
        });
        this.masonryItems = [];

        // Map items and build markup
        if ( items.length > 0 ) {

            let output = [];
            let loadedImages = 0;


            // Async image counter
            let isFinisedLoading = function() {

                if (loadedImages === items.length) {

                    output.map($item => {
                        this.masonryContainer.append($item);
                        this.masonry.appended( $item[0] );
                        this.masonryItems.push( $item[0] );
                        this.registerWaypoint( $item[0] );
                    })

                };
            }.bind(this)

            items.forEach( item => {

                const markup = this.buildMarkup(item);
                output.push( markup.markup );

                // Count loaded images
                if ( markup.image ) {

                    let loadImage = new imagesLoaded( markup.image, () => {
                        loadedImages++;
                        isFinisedLoading();
                    })

                } else {
                    
                    loadedImages++;
                    isFinisedLoading();

                }

                

            });

        } else {

            this.showEmpty();

        }

        setTimeout(() => {
            this.masonry.layout();
        }, 100);
        

    }


    fetchEmployees() {

        $.ajax({
            method: 'GET',
            url: '/api/v1/employees',
            data: {
                search: this.query
            },
        }).done(response => {

            this.renderItems(response.data);
            this.masonry.layout();

        })

        setTimeout(() => {
            this.searchInput.attr('disabled', false);
        }, 500);
    }


    registerEvents() {

        this.searchInput.on('keyup', event => {
            this.query = event.target.value;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.searchInput.attr('disabled', true);
                this.fetchEmployees();
            }, 250);
        });

        $('form[name="search-employees"]').on('submit', event => {
            event.preventDefault();
        });

    }


    init() {

        this.masonry = new Masonry(this.masonryContainer[0], {
            columnWidth: '.grid-sizer',
            itemSelector: '.employees-list--item',
            percentPosition: true,
            horizontalOrder: true,
            transitionDuration: '0.3s',
            stagger: 10
        });

        this.registerEvents();
        this.fetchEmployees();

    }

}


class L2Arkitekter {

    constructor() {
        
        this.siteHeader = document.getElementById('site-header');

        this.init();

    }

    siteHeaderModifier() {

        const getScrollY = () => Math.max(
            window.scrollY || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
        );

        let lastScrollY = getScrollY();

        // Use capture:true so this fires even if body is the scroll container
        window.addEventListener('scroll', () => {

            const scrollY = getScrollY();

            // Close mobile menu on any scroll
            this.siteHeader.classList.remove('open-navigation');

            // Always show header when near the top of the page
            if (scrollY < 100) {
                this.siteHeader.classList.remove('hidden');
                lastScrollY = scrollY;
                return;
            }

            // Hide when scrolling down, show when scrolling up
            if (scrollY > lastScrollY) {
                this.siteHeader.classList.add('hidden');
            } else {
                this.siteHeader.classList.remove('hidden');
            }

            lastScrollY = scrollY;

        }, { capture: true, passive: true });

    }

    registerEvents() {

        $('.main-menu-toggle').on('click', function(event) {

            event.preventDefault();
            $('.site-header').toggleClass('open-navigation');

        });

        const arrow = document.querySelector('.hero-image__arrow');
        if (arrow) {
            arrow.addEventListener('click', () => {
                const hero = document.querySelector('.hero-image');
                if (hero && hero.nextElementSibling) {
                    hero.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }

    }


    languageSwitcher() {

        let container = $('.language-switcher');

        if ( container.length === 0 ) {
            return;
        }

        let toggler = container.find('button'),
            className = 'toggle-language';

        toggler.on('click', function() {

            let isToggled = container.hasClass(className)
            if ( isToggled ) {
                container.removeClass(className);
                toggler.html(toggler.data('original'));
            } else {
                container.addClass(className);
                toggler.html(toggler.data('toggled'));
            }
        });
    }



    initGoogleMaps() {

        let init = ( item ) => {

            let container = item[0],
                position = {
                    lat: parseFloat(item.data('lat')),
                    lng: parseFloat(item.data('lng')),
                },
                zoom = parseFloat(item.data('zoom')),
                baseUrl = item.data('baseurl');

            let map = new google.maps.Map(container, {
                center: position,
                zoom: zoom,
                styles: [ { "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "elementType": "labels.text.fill", "stylers": [ { "color": "#616161" } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "color": "#f5f5f5" } ] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [ { "color": "#bdbdbd" } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#eeeeee" } ] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#e5e5e5" } ] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [ { "color": "#9e9e9e" } ] }, { "featureType": "road", "elementType": "geometry", "stylers": [ { "color": "#ffffff" } ] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [ { "color": "#757575" } ] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [ { "color": "#dadada" } ] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [ { "color": "#616161" } ] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [ { "color": "#9e9e9e" } ] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [ { "color": "#e5e5e5" } ] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [ { "color": "#eeeeee" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#c9c9c9" } ] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#9e9e9e" } ] } ]
            });

            let marker = new google.maps.Marker({
                position: position,
                map: map,
                icon: {
                    url: window.location.origin+'/assets/brand/mapmarkers/L2_Map_pin.png',
                    size: new google.maps.Size(110, 20),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(110, 20)
                }
            });

        }

        window.initMap = function() {
            
            $.each($('.google-map'), function() {
                init($(this));
            });

        }

    }

    initNewsFeature() {
        const feature = document.querySelector('.news-feature');
        if (!feature) return;

        feature.querySelectorAll('.news-feature__ingress [style], .news-feature__text [style]').forEach(el => {
            el.removeAttribute('style');
        });
    }

    stripFieldStyles() {
        document.querySelectorAll(
            '.standard-contentblock .text [style], .alternative-contentblock .text-container [style], .contact-header .text [style]'
        ).forEach(el => el.removeAttribute('style'));
    }

    initNewsMasonry() {
        const container = document.querySelector('.news-list');
        if (!container) return;

        const articles = window.newsArticles || [];
        const loadMoreBtn = document.querySelector('.news-load-more');
        const pageSize = 6;
        let currentIndex = 0;
        let masonry = null;

        const createItem = (article) => {
            const item = document.createElement('div');
            item.className = 'news-list-item';

            if (article.image) {
                const img = document.createElement('img');
                img.src = article.image;
                img.alt = '';
                item.appendChild(img);
            }

            const title = document.createElement('h2');
            title.className = 'news-list-item__title';
            title.textContent = article.title;
            item.appendChild(title);

            if (article.ingress) {
                const ingress = document.createElement('div');
                ingress.className = 'news-list-item__ingress';
                const tempIngress = document.createElement('div');
                tempIngress.innerHTML = article.ingress;
                tempIngress.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
                ingress.innerHTML = tempIngress.innerHTML;
                item.appendChild(ingress);
            }

            if (article.body) {
                const body = document.createElement('div');
                body.className = 'news-list-item__body';
                const temp = document.createElement('div');
                temp.innerHTML = article.body;
                temp.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
                temp.querySelectorAll('[data-olk-copy-source]').forEach(el => el.removeAttribute('data-olk-copy-source'));
                body.innerHTML = temp.innerHTML;
                item.appendChild(body);
            }

            return item;
        };

        const isDesktop = () => window.innerWidth >= 1024;

        const initMasonry = () => {
            if (masonry || !isDesktop()) return;
            masonry = new MiniMasonry({
                container: container,
                baseWidth: 500,
                gutterX: 80,
                gutterY: 120,
                surroundingGutter: false,
            });
        };

        const destroyMasonry = () => {
            if (!masonry) return;
            masonry.destroy();
            masonry = null;
        };

        window.addEventListener('resize', () => {
            if (isDesktop()) {
                initMasonry();
            } else {
                destroyMasonry();
            }
        });

        const loadMore = () => {
            const batch = articles.slice(currentIndex, currentIndex + pageSize);
            currentIndex += pageSize;

            if (loadMoreBtn) {
                loadMoreBtn.disabled = true;
                loadMoreBtn.classList.add('is-loading');
            }

            batch.forEach(article => container.appendChild(createItem(article)));

            if (currentIndex >= articles.length && loadMoreBtn) {
                loadMoreBtn.style.display = 'none';
            }

            imagesLoaded(container, () => {
                if (isDesktop()) {
                    if (masonry) {
                        masonry.layout();
                    } else {
                        initMasonry();
                    }
                }

                if (loadMoreBtn) {
                    loadMoreBtn.disabled = false;
                    loadMoreBtn.classList.remove('is-loading');
                }
            });
        };

        if (loadMoreBtn) {
            if (articles.length <= pageSize) {
                loadMoreBtn.style.display = 'none';
            }
            loadMoreBtn.addEventListener('click', loadMore);
        }

        loadMore();
    }

    initProjectSwiper() {
        const swiperContainers = document.querySelectorAll('.swiper');
        if (!swiperContainers.length) return;

        swiperContainers.forEach(container => {
            new Swiper(container, {
                loop: true,
                centeredSlides: true,
                slidesPerView: 1.2,
                spaceBetween: 16,
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                scrollbar: {
                    el: container.querySelector('.swiper-scrollbar'),
                    draggable: true,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 45,
                    },
                },
            });
        });
    }



    init() {

        history.scrollRestoration = 'manual';
        document.body.scrollTop = 0;

        this.registerEvents();
        this.initGoogleMaps();
        this.languageSwitcher();
        this.siteHeaderModifier();
        this.initNewsFeature();
        this.stripFieldStyles();
        this.initNewsMasonry();
        this.initProjectSwiper();

        // HideHeaderOnScroll( document.getElementById('site-header') );
        FadeInWaypoints();

        const employeeList = new searchEmployees;

    }

};

// Do the damn thing!
const app = new L2Arkitekter;